export const DRAWING_PREVIEW_WIDTHS = Object.freeze([128, 256, 512, 1024]);
const MIN_ACCEPTABLE_SCALE = 0.85;

const positiveNumber = (value, fallback) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const drawingRequestWidth = (componentWidth, viewportWidth) => {
    const cssWidth = positiveNumber(componentWidth, 100);
    const viewport = positiveNumber(viewportWidth, cssWidth);
    const targetWidth = Math.min(cssWidth, viewport);

    for (let index = 0; index < DRAWING_PREVIEW_WIDTHS.length; index += 1) {
        const width = DRAWING_PREVIEW_WIDTHS[index];
        if (width < targetWidth) continue;

        const previousWidth = DRAWING_PREVIEW_WIDTHS[index - 1];
        // Una lieve riduzione evita una variante più pesante; il PDF originale
        // resta disponibile al clic quando serve leggere il dettaglio completo.
        if (previousWidth && previousWidth / targetWidth >= MIN_ACCEPTABLE_SCALE) {
            return previousWidth;
        }
        return width;
    }

    return DRAWING_PREVIEW_WIDTHS[DRAWING_PREVIEW_WIDTHS.length - 1];
};
